class FingerPrintModule {
    static fingerPrintModules = null;

    static importFingerPrintWrapper() {
        if (FingerPrintModule.fingerPrintModules) {
            return new Promise(resolve => {
                return resolve(FingerPrintModule.fingerPrintModules);
            });
        }
        return import(/* webpackChunkName: "FingerPrintWrapper" */'./deviceFingerPrint').then(module => {
            FingerPrintModule.fingerPrintModules = module;
            return FingerPrintModule.fingerPrintModules;
        });
    }
}

export default FingerPrintModule;
